export class ReelHistorySearch {
    constructor() {
        this.form = document.querySelector('form');
        this.searchButton = this.form.querySelector('div.btn.btn-success.search');
        this.clearButton = document.getElementById('clearButton');
        this.downloadButton = document.getElementById('downloadButton');
        this.printButton = document.getElementById('printButton');
        this.tableBody = document.getElementById('tableBody');
        this.resultTable = document.getElementById('resultTable');
        this.rzNumber2 = document.getElementById('rz_number2');
        this.rzMaterialSwitch = document.getElementById('rzMaterialSwitch');

        this.addEventListener();
    }

    addEventListener() {
        this.rzMaterialSwitch.addEventListener('change', this.toggleRZType.bind(this));

        this.form.addEventListener('keydown', (event) => {   // перехватываем Enter в форме
            if (event.key === 'Enter') {
                event.preventDefault();   // блокируем нативную отправку формы
                this.search(this.searchButton);   // имитируем клик по кнопке "Искать"
            }
        });
    }

    toggleClearButton() {
        if (this.tableBody.rows.length > 0) {
            this.clearButton.style.display = 'inline-block';
            this.downloadButton.style.display = 'inline-block';
            this.printButton.style.display = 'inline-block';
            $(this.resultTable).fadeIn(); // Show table smoothly if it has data
        } else {
            this.clearButton.style.display = 'none';
            this.downloadButton.style.display = 'none';
            this.printButton.style.display = 'none';
            $(this.resultTable).fadeOut(); // Hide table if empty
        }
    }

    toggleRZType() {
        const isGive = this.rzMaterialSwitch.checked;
        this.rzNumber2.disabled = isGive;
        this.rzNumber2.value = '';

        this.rzMaterialSwitch.textContent = isGive ? 'Давальческие материалы' : 'Собственные материалы';
    }

    async search(btn) {
        if (await validateForm({ elem: btn })) {
            const formData = getDataAll(btn.closest('fieldset'));

            // Disable button and show spinner
            btn.disabled = true;
            btn.classList.add('disabled');

            const spinner = document.createElement('span');
            spinner.classList.add('spinner-border', 'spinner-border-sm', 'ms-2');
            btn.appendChild(spinner);

            // Clear table
            this.tableBody.innerHTML = '';
            $(this.resultTable).fadeOut();
            this.toggleClearButton();

            new SendData({
                data: formData,
                url: '/do/doReel_history_search'
                // url: '<?= Redirect::route('doReel_history_search') ?>'
            }).then(response => {
                const answer = response.answer;

                if (answer) {
                    this.tableBody.innerHTML = answer;
                    $(this.resultTable).fadeIn();
                    this.toggleClearButton();
                }
            }).finally(() => {
                // Remove spinner and re-enable button
                btn.disabled = false;
                btn.classList.remove('disabled');
                spinner.remove();
            });
        }
    }
}